<div class="wizard-wrapper tw-flex tw-flex-col tw-flex-1 tw-h-full tw-w-full tw-relative">
    <div class="step-container tw-w-full tw-overflow-y-auto tw-flex tw-flex-col tw-snap-y tw-snap-mandatory tw-overscroll-y-contain tw-scroll-smooth" #stepContainer>
        <div data-step="1" class="step-content tw-w-full tw-snap-start tw-snap-always" #stepEl>
            <app-event-identity
                [eventData]="eventData()"
                [isLoading]="isLoading()"
                [organizationId]="eventData()?.workspace_id"
                [eventId]="eventData()?.id"
                [isSaving]="isSavingField()"
                (fieldChanged)="updateEventData($event)"
                (titleChanged)="onTitleChanged($event)"
                [industrySectors]="industrySectorsSignal()"
            ></app-event-identity>
        </div>
        <div data-step="2" class="step-content tw-w-full tw-snap-start tw-snap-always" #stepEl>
            <app-location-time-zone
            [checkin]="eventData()?.checkins?.[0] ?? null"
            [organizationId]="eventData()?.workspace_id"
            [eventId]="eventData()?.id"
            [eventTimezoneOffsetString]="eventData()?.timezone_offset_string"
            [isSaving]="isSavingField()"
            (locationDetailsChange)="onLocationDetailsChange($event)"
            ></app-location-time-zone>
        </div>
        <div data-step="3" class="step-content tw-w-full tw-min-h-full tw-snap-start tw-snap-always" #stepEl>
            <app-event-dates-and-timings
                [event]="eventData()"
                (finish)="onFinish()"
            ></app-event-dates-and-timings>
        </div>
    </div>
    <div class="stepper-container tw-absolute tw-z-10 tw-bg-transparent tw-right-0 tw-w-full tw-h-[100px] tw-flex tw-items-center lg:tw-top-[6.3rem] lg:tw-w-auto lg:tw-h-[56vh] lg:tw-justify-center tw-px-4 lg:tw-px-0">
        <app-stepper [currentStep]="currentStep()" [totalSteps]="totalSteps" (stepChanged)="onStepChanged($event)" class="tw-w-full"></app-stepper>
    </div>
</div>

<app-unsaved-changes-modal
    [id]="UNSAVED_MODAL_ID"
    (saveChanges)="saveChangesAndLeave()"
    (cancel)="discardChangesAndLeave()"
    (dismissed)="closeUnsavedModalOnly()"
></app-unsaved-changes-modal>
